import React, { useState, useEffect, useMemo } from "react";
import { Modal, Icon, Checkbox, Spin, Tooltip } from "antd";
import NewLoader from "../../../../../components/styled-components/loader/NewLoader";
import { debounce } from "lodash";
import moment from "moment";
import BUDGET_API from "../../../../../apis/budget.api";
import swal from "sweetalert";
import helpIcon from "../../../../../assets/images/DeathModuleNew/IC_Help.png";
export const EditRecurringPattren = ({
  open,
  handleCancel,
  handleSave,
  handleDelete,
  handleSaveAddPattren,
  handleSaveRule,
  handleChange,
  data,
  loading,
}) => {
  const [patterns, setPatterns] = useState(
    (data && data.recurring_patterns) || []
  );
  const [editedPatternId, setEditedPatternId] = useState(null);
  const [newPattern, setNewPattern] = useState(null);
  const [selectAll, setSelectAll] = useState(false);
  const [isEditingRule, setIsEditingRule] = useState(false);
  const [editedRule, setEditedRule] = useState(data && data.token || "");
  const [applyToExistingTransactions, setApplyToExistingTransactions] = useState(false);


  const [searchResults, setSearchResults] = useState([]);
  const [searchResultsPrevious, setSearchResultsPrevious] = useState([]);
  const [appliedTransactions, setAppliedTransactions] = useState([]);
  const [selectedTransactions, setSelectedTransactions] = useState([]);
  const [searchLoading, setSearchLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [loadingMore, setLoadingMore] = useState(false);
  const [ totalFoundTransactions, setTotalFoundTransactions] = useState(null)

  const [isModalOpen, setIsModalOpen] = useState(false);
  
  const handlePatternChange = (id, field, value) => {
    if (value === "") {
      setTotalFoundTransactions(null);
    }
    setPatterns((prev) =>
      prev.map((pattern) =>
        pattern.id === id ? { ...pattern, [field]: value } : pattern
      )
    );
    setSelectAll(false);
  };
  const getAppliedTransactions = async (patternId) => {
    try {
      setSearchLoading(true);
  
      // Step 1: Fetch first page to get total pages
      const firstRes = await BUDGET_API.fetchRecurringPattrenAppliedTransaction(
        data.id,
        patternId,
        1,
        10
      );
      // const firstPageData = firstRes.data.transactions || [];
      const firstPageData = (firstRes.data.transactions || []).filter(
        (txn) => txn.patternId === patternId
      );
      const totalPages = firstRes.data.totalPages || 1;
  
      // Step 2: Prepare requests for remaining pages
      const fetchPromises = [];
  
      for (let page = 2; page <= totalPages; page++) {
        fetchPromises.push(
          BUDGET_API.fetchRecurringPattrenAppliedTransaction(
            data.id,
            patternId,
            page,
            10
          )
        );
      }
  
      // Step 3: Await all requests
      const results = await Promise.all(fetchPromises);
  
      // Step 4: Merge all transactions
      const remainingData = results.flatMap(res => res.data.transactions || []);
      // const allTransactions = [...firstPageData, ...remainingData];
      // Do something with allTransactions
      const allTransactions = [...firstPageData, ...remainingData]
      .map(item => ({...item.transaction, patternId :item.patternId}))
      .filter(Boolean); 
      console.log("Fetched transactions:", allTransactions);
      if(allTransactions){
        const uniqueTransactions = Array.from(
          new Map(allTransactions.map(item => [item.id, item])).values()
        );
        setSearchResults(uniqueTransactions);
        setAppliedTransactions(uniqueTransactions)
        setSearchResultsPrevious(uniqueTransactions);
        // setSelectAll(true);
        // const transactionIds = uniqueTransactions.map((t) => t.id);
        // setSelectedTransactions(uniqueTransactions);
        
        const pattern = patterns.find(p => p.id === patternId);

        const selectedIds = pattern && pattern.selectedTransactionIds || [];

        const selected = uniqueTransactions.filter(t =>
          selectedIds.includes(t.id)
        );
        // const selected = allTransactions ? allTransactions.map(i => i.id) : [];

      setSelectedTransactions(uniqueTransactions && uniqueTransactions.map(i=>i));
      }
  
      setSearchLoading(false);
    } catch (error) {
      console.error("Error fetching transactions:", error);
      setSearchLoading(false);
    }
  };

  const savePattern = async(id) => {
    const patternToSave = patterns && patterns.find((pattern) => pattern.id === id);
       
    if(patternToSave && patternToSave.pattern === ""){
      swal("Oops!", "Pattern can not be empty", "warning");
      return
    }
    // const allTransactionIds = searchResultsPrevious ? searchResultsPrevious.map((t) => t.id) : [];
    const allTransactionIds = selectedTransactions ? selectedTransactions.map((t) => t.id) : [];
    const filteredTransactions = selectedTransactions ? selectedTransactions.filter(
      (transaction) => !allTransactionIds.includes(transaction.id)
    ) : [];
    let payload = {
      patternId: id,
      pattern: patternToSave && patternToSave.pattern,
      tokenId: data.id,
      selectedTransactions:allTransactionIds && allTransactionIds.map(id => ({ id })),
      selectAll: selectAll,
    };

    console.log("payload", payload);
    await handleSave(payload);
    setPatterns((prev) =>   
      prev.map((p) =>
        p.id === id
          ? { ...p, selectedTransactionIds: selectedTransactions.map(t => t.id) }
          : p
      )
    );
    setEditedPatternId(null); // Exit edit mode
    setSelectedTransactions([]);
    setCurrentPage(1);
    setTotalPages(1);
    setSearchResults([]);
    setSearchResultsPrevious([]);
    setAppliedTransactions([]);
  };
  const deletePattern = async(id) => {
    let payload = {
      patternId: id,
      tokenId: data.id,
    };
    await handleDelete(payload);
    setPatterns((prev) => prev.filter((pattern) => pattern.id !== id));
    console.log("payload", payload);
    setEditedPatternId(null); // Exit edit mode
  };
  const handleAddPattern = () => {
    const newId = Date.now(); // Generate a unique ID for new patterns
    setNewPattern({ id: newId, pattern: "" });
    setEditedPatternId(newId);
    setSearchResults([]);
    setSelectedTransactions([]);
  };
  const handleRemovePattern = (id) => {
    setPatterns((prev) => prev.filter((pattern) => pattern.id !== id));
    
    // Optionally clear selection or editing state if removed item was being edited
    if (editedPatternId === id) {
      setEditedPatternId(null);
      setNewPattern(null);
      setSearchResults([]);
      setSelectedTransactions([]);
    }
  };
  const saveNewPattern = async () => {
    if (newPattern && newPattern.pattern.trim() !== "") {
      const payload = {
        pattern: newPattern && newPattern.pattern,
        tokenId: data && data.id,
      };
      console.log("payload", payload);
      const res = await handleSaveAddPattren(payload);
      // console.log("res pattren", res.body.result);
      
      if (res && res.body && res.body.result && res.body.result) {
        setPatterns([...patterns, res.body.result]);
      }
      console.log("resresresres",res)
      const allTransactionIds = searchResultsPrevious && searchResultsPrevious.map((t) => t.id) || [];
      const selectedTransactionsIds= selectedTransactions && selectedTransactions.map((row) => row.id);
      const filteredTransactionIds = selectedTransactionsIds && selectedTransactionsIds.filter(
        (id) => !allTransactionIds.includes(id)
      );
      console.log("filteredTransactionIds",filteredTransactionIds,selectedTransactions,selectedTransactionsIds)
      // const payloadData={
      //   tokenId : data.id,
      //   patternId :res && res.body && res.body.result && res.body.result && res.body.result.id,
      //   transactionIds:filteredTransactionIds,
      // }
      const payloadData = data && selectAll
    ? {
        tokenId : data.id,
        patternId :res && res.body && res.body.result && res.body.result && res.body.result.id,
        selectAll: true,
      }
    : {
        tokenId : data.id,
        patternId :res && res.body && res.body.result && res.body.result && res.body.result.id,
        transactionIds:selectedTransactionsIds && selectedTransactionsIds,
      };
      let dataRes = await BUDGET_API.createTransactionsForRecurring(payloadData);

      setNewPattern(null);
      setEditedPatternId(null);
      setSelectedTransactions([]);
      setCurrentPage(1);
      setTotalPages(1);
      setSearchResults([]);
      setSearchResultsPrevious([]);
      setAppliedTransactions([]);
    }
  };
  const handleSelectAllChange = (e) => {
    const checked = e.target.checked;
    setSelectAll(checked);

    // if (!inputValue) return;

    if (checked) {
      setSelectedTransactions((prevSelected) => {
        const searchIds = new Set(searchResults.map((t) => t.id));
        const allSelected = searchResults.every((t) =>
          prevSelected.some((p) => p.id === t.id)
        );
      
        if (allSelected) {
          // If all searchResults already selected → remove them
          return prevSelected.filter((t) => !searchIds.has(t.id));
        } else {
          // Add only unique searchResults
          const existingIds = new Set(prevSelected.map((t) => t.id));
          const newItems = searchResults.filter((t) => !existingIds.has(t.id));
          return [...prevSelected, ...newItems];
        }
      });
    } else {
      setSelectedTransactions((prevSelected) => {
        const idsToRemove = searchResults && searchResults.map((t) => t.id);
        return prevSelected.filter((t) => !idsToRemove.includes(t.id));
      });
    }
  };

  const toggleTransactionSelection = (transaction) => {
    console.log("transaction", transaction);
    if(selectAll===true){
      setSelectAll(false)
    }
    setSelectedTransactions((prevSelected) => {
      const isSelected = prevSelected.some((t) => t.id === transaction.id);
      if (isSelected) {
        return prevSelected.filter((t) => t.id !== transaction.id);
      } else {
        return [...prevSelected, transaction];
      }
    });
  };
  const searchPatternTransactions = useMemo(
    () =>
      debounce(async (query, page = 1, limit = 10) => {
        if (!query) {
          if(newPattern!==null){
            setSearchResults([]);
          }
          return;
        }
        setSearchLoading(true);
        try {
          let response = await BUDGET_API.searchRecurringAppliedTransaction(
            page,
            limit,
            query
          );
          if (response && response.data) {
            // setSearchResults((prev) =>
            //   page === 1 ? [...appliedTransactions, ...response.data] : [...prev, ...response.data]
            // );
            // const newResults = page === 1
            //     ? [...appliedTransactions, ...response.data]
            //     : [...searchResults, ...response.data]; // use current state directly to avoid stale `prev`

            // // Deduplicate by `id`
            // const uniqueResults = Array.from(
            //   new Map(newResults.map(item => [item.id, item])).values()
            // );
            // setSearchResults(uniqueResults);
            setTotalFoundTransactions(response.total);
            setSearchResults(prev => {
              const newResults =
                page === 1
                  ? [...appliedTransactions, ...response.data]
                  : [...prev, ...response.data];
            
              const uniqueResults = Array.from(
                new Map(newResults.map(item => [item.id, item])).values()
              );
            
              return uniqueResults;
            });
            setTotalPages(response.totalPages);
            setCurrentPage(page);
          }else{
            setTotalFoundTransactions(null);
          }
        } catch (error) {
          console.error("Error fetching transactions:", error);
        }
        setSearchLoading(false);
      }, 500),
    [appliedTransactions]
  );
  useEffect(() => {
    return () => {
      searchPatternTransactions.cancel();
    };
  }, []);
  const handleScroll = () => {
    const container = document.getElementById("transactions-search");
    if (!container) return;

    const { scrollTop, scrollHeight, clientHeight } = container;

    if (
      scrollTop + clientHeight >= scrollHeight - 10 &&
      !loadingMore &&
      currentPage < totalPages
    ) {
      setLoadingMore(true);
      const query =
        (editedPatternId !== null && newPattern===null)
          ? (patterns && patterns.find((p) => p.id === editedPatternId) ? patterns.find((p) => p.id === editedPatternId).pattern : "")
          : (newPattern && newPattern.pattern) || "";
      if(query){
        searchPatternTransactions(query, currentPage + 1);
      }
      setLoadingMore(false);
    }
  };
  const handleApplyRuleToExistingTransactions = (e) => {
    setApplyToExistingTransactions(prev => !prev)
    handleChange(e.target.name, e.target.checked)
  }
  return (
    <div>
    <Modal
      visible={open}
      footer={null}
      onOk={handleCancel}
      onCancel={handleCancel}
      closable={false}
      centered
    >
      <h3 className="modaltitle">Recurring Pattern Update</h3>

      <div
        style={{ marginTop: "1rem", maxHeight: "25rem", overflow: "scroll" }}
      >
        <div style={{ marginBottom: "8px" }}>
          <h3 className="inputTitle">
            Rule <span style={{ color: "red" }}>*</span>
          </h3>
          <div style={{display:'flex', alignItems:'center',columnGap:'0.8rem'}}>
          <input
            name="token"
            id="token"
            className="roleInput"
            placeholder="Rule Name"
            value={data && data.token}
            disabled={!isEditingRule}
            onChange={(e) => {
                e.preventDefault();
                handleChange(e.target.name, e.target.value);
              }}
            style={{
              cursor: isEditingRule ? "text" : "not-allowed",
              background: "#FAFAFA",
              fontWeight: "bold",
            }}
          />
          {!isEditingRule ? (
            <Icon
              type="edit"
              style={{ fontSize: "18px", color: "#2a3da3",padding:"0 5px 0 0" }}
              onClick={() => {
                setEditedRule(data && data.token || "");
                setIsEditingRule(true);
              }}
            />
          ) : (
            <>
              <Icon
                type="close"
                style={{color:"red",fontSize:"20px"}}
                onClick={() => setIsEditingRule(false)} 
              />
              <Icon
                type="save"
                style={{ fontSize: "18px", color: "#2a3da3",padding:"0 5px 0 0" }}
                onClick={() => {
                  if (editedRule.trim() === "") {
                    swal("Oops!", "Rule cannot be empty", "warning");
                    return;
                  }
                  // handleChange("token", editedRule.trim());
                  handleSaveRule();
                  setIsEditingRule(false);
                  handleCancel()
                }}
              />
            </>
          )}
          </div>
        </div>
        {isEditingRule && <div>
            <Checkbox
              name="applyRuleToExistingTransactions"
              id="applyRuleToExistingTransactions"
              checked={applyToExistingTransactions}
              onChange={handleApplyRuleToExistingTransactions}
            />
            <label htmlFor="applyRuleToExistingTransactions" style={{ marginLeft: 8 }}>
              Do you want to apply this rule to existing transactions?
            </label>
          </div>}
        <div className="patterns-display" style={{maxHeight:"100%"}}>

          <h3 className="inputTitle">
            Patterns
          </h3>
          

          {patterns.map((pattern) => (
            <div key={pattern.id} className="patternItem" style={{display:"flex",flexDirection:"column",paddingInline:"4px"}}>
            <div className="patternItem" style={{width:"100%"}}>
              {editedPatternId === pattern.id ? (
                <div style={{width:"100%"}}>
                <div style={{display: "flex",alignItems: "center",gap: "1rem",}}>
                  <input
                    className="roleInput"
                    value={pattern.pattern}
                    style={{ fontWeight:"bold",background:"#FAFAFA"}}
                    onChange={(e) => {
                      handlePatternChange(
                        pattern.id,
                        "pattern",
                        e.target.value
                      );
                      searchPatternTransactions(e.target.value, 1);
                    }}
                  />
                  <div
                  style={{
                    display: "flex",
                    gap: "8px",
                    alignItems: "center",
                  }}
                >
                  <Icon
                    type="close"
                    style={{color:"red",fontSize:"20px"}}
                    onClick={() => {
                      setEditedPatternId(null);
                      setSelectAll(false);
                      setSelectedTransactions([]);
                      setSearchResults([]);
                      setSearchResultsPrevious([]);
                      setAppliedTransactions([]);
                      setTotalPages(1);
                      setCurrentPage(1);
                    }}
                  />
                  <Icon
                    type="save"
                    style={{color:"#2a3da3",fontSize:"20px"}}
                    onClick={() => {
                      if (editedPatternId === pattern.id) {
                        savePattern(pattern.id);
                      }
                    }}
                  />
                  </div>
                  </div>
                  <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    // alignItems: "center",
                  }}
                >
                  {searchResults.length > 0 && (
                    <div>
                      <Checkbox
                        id="selectAllSearch"
                        checked={selectAll}
                        onChange={handleSelectAllChange}
                      />
                      <label htmlFor="selectAllSearch" style={{ marginLeft: 8 }}>
                        Select All
                      </label>
                      <Tooltip title={'Select All will include all transactions matching the above pattern....'}>
                    <img
                      style={{
                      cursor: "pointer",
                      marginLeft: "8px",
                      width: "25px",
                      height: "25px",
                      }}
                      src={helpIcon}
                      alt="helpicon"
                      ></img>
                  </Tooltip>
                    </div>
                  )}
                  <div
                  style={{
                    cursor: "pointer",
                    textDecoration: "underline",
                    color: "#2a3da3",
                    paddingInline:"4px"
                  }}
                  onClick={() => {
                    console.log("selectedTransactions", selectedTransactions);
                    setIsModalOpen(true);
                  }}
                >
                  {/* {selectedTransactions.length > 0 &&
                    "Selected Transactions " + selectedTransactions.length} */}
                  {(selectAll
                    ? (searchResults.length > 0 && totalFoundTransactions && 
                        `Selected Transactions ${totalFoundTransactions}`)
                    : (selectedTransactions.length > 0 && 
                        `Selected Transactions ${selectedTransactions.filter(item => item.patternId === pattern.id).length}`))}
                </div>
                <div>
                  {searchResults.length > 0 &&
                    totalFoundTransactions &&
                    "Total Transactions " + totalFoundTransactions}
                </div>
                </div>
              {searchLoading && <Spin />}
              {!searchResults ? (
                <Spin />
              ) : !selectAll ? (
                <div
                  className="searchResults"
                  style={{ maxHeight: "10rem", overflowY: "auto",width:"100%" }}
                  id="transactions-search"
                  onScroll={handleScroll}
                >
                  {searchResults.length > 0 ? (
                    searchResults.map((transaction) =>  transaction.patternId === pattern.id &&(
                      <div
                        key={transaction.id}
                        style={{
                          display: "flex",
                          alignItems: "center",
                          padding: "8px",
                          borderBottom: "1px solid #ddd",
                          cursor: "pointer",
                        }}
                        onClick={() =>
                          toggleTransactionSelection(transaction)
                        }
                      >
                        <Checkbox
                          checked={selectedTransactions.some(
                            (t) => t.id === transaction.id
                          )}
                          onClick={(event) => event.stopPropagation()}
                          onChange={(event) => {
                            event.stopPropagation(); // Prevents the div's onClick from being triggered
                            toggleTransactionSelection(transaction);
                          }}
                          // onChange={() => toggleTransactionSelection(transaction)}
                        />
                        <span style={{ marginLeft: "1rem" }}>
                          {transaction.itemName}
                        </span>
                        <span style={{ marginLeft: "1rem" }}>
                          {transaction.date
                            ? moment(transaction.date).format("MM-DD-YYYY")
                            : "N/A"}
                        </span>
                        {transaction.amount &&
                        <span style={{ marginLeft: "1rem" }}>
                          {transaction.amount }
                        </span>
                        }
                      </div>
                    ))
                  ) : (
                    <p style={{ color: "#aaa", textAlign: "center" }}>
                      No transactions found
                    </p>
                  )}
                </div>
              ) : null} 
                </div>
              ) : (
                <input
                  className="roleInput"
                  style={{ fontWeight:"bold",background:"#FAFAFA",cursor:"not-allowed"}}
                  value={pattern.pattern}
                  readOnly
                  disabled={true}
                />
              )}
              <span
                style={{
                  fontSize: "20px",
                  fontWeight: "600",
                  cursor: "pointer",
                }}
                // onClick={() =>
                //   editedPatternId === pattern.id
                //     ? savePattern(pattern.id)
                //     : setEditedPatternId(pattern.id)
                // }
              >
                {editedPatternId === pattern.id ? (
                  null
                ) : (
                  <div
                    style={{
                      display: "flex",
                      gap: "8px",
                      alignItems: "center",
                    }}
                  >
                    <Icon
                      type="edit"
                      style={{color:"#2a3da3"}}
                      color="#2a3da3"
                      onClick={() => {
                        getAppliedTransactions(pattern.id);
                        setEditedPatternId(pattern.id);
                      }}
                    />
                    <Icon
                      type="delete"
                      style={{color:"red"}}
                      onClick={() => {
                        deletePattern(pattern.id);
                      }}
                    />
                  </div>
                )}
              </span>
              </div>
              
            </div>
          ))}
          <div style={{ display: "flex", justifyContent: "flex-start",alignItems:"center", gap:"8px" ,width:"fit-content",cursor:"pointer"}}  onClick={() => {
            handleAddPattern();
          }}>
            <Icon
              type="plus-circle"
              color="black"
              style={{ fontSize: "20px", fontWeight: "bold",color:"#2a3da3" }}
             
            /> <span style={{ fontSize: "14px", fontWeight: "bold",color:"#2a3da3" }}>Add Pattern </span>
          </div>
          {newPattern && (
            <React.Fragment>
              <div className="patternItem" style={{ paddingInline: "0.3rem",width:"98%" }}>
                <input
                  className="roleInput"
                  value={newPattern.pattern}
                  style={{background:"#FAFAFA",fontWeight:"bold" }}
                  onChange={(e) => {
                    setNewPattern({ ...newPattern, pattern: e.target.value });
                    searchPatternTransactions(e.target.value, 1);
                    if(e.target.value===""){
                      setSearchResults([]);
                      setSelectedTransactions([]);
                    }
                  }}
                />
                <Icon
                type="close"
                style={{color:"red",fontSize:"20px"}}
                onClick={() => handleRemovePattern(newPattern.id)} 
              />
                <Icon
                  type="save"
                  color="black"
                  // style={{ fontSize: "20px", fontWeight: "bold",color:"#2a3da3" }}
                  style={{
                    fontSize: "20px",
                    fontWeight: "bold",
                    color: "#2a3da3",
                    cursor: (selectedTransactions.length < 1) ? "not-allowed" : "pointer",
                    pointerEvents: (selectedTransactions.length < 1) ? "none" : "auto",
                    opacity: ( selectedTransactions.length < 1) ? 0.5 : 1,
                  }}
                  disable={true}
                  // onClick={saveNewPattern}
                  onClick={
                     selectedTransactions.length < 1
                      ? undefined
                      : saveNewPattern
                  }
                />
              </div>
              {searchLoading && <Spin />}
              <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                  }}
                >
              {searchResults.length > 0 && (
                <div>
                  <Checkbox
                    id="selectAllSearch"
                    checked={selectAll}
                    onChange={handleSelectAllChange}
                  />
                  <label htmlFor="selectAllSearch" style={{ marginLeft: 8 }}>
                    Select All
                  </label>
                  <Tooltip title={'Select All will include all transactions matching the above pattern....'}>
                    <img
                      style={{
                      cursor: "pointer",
                      marginLeft: "8px",
                      width: "25px",
                      height: "25px",
                      }}
                      src={helpIcon}
                      alt="helpicon"
                      ></img>
                  </Tooltip>
                </div>
                
              )}
              <div
              style={{
                cursor: !selectAll ? "pointer" : "default",
                textDecoration: !selectAll ? "underline" : 'none',
                color: "#2a3da3",
                paddingInline:"4px"
              }}
              onClick={() => {
                console.log("selectedTransactions", selectedTransactions);
                !selectAll && setIsModalOpen(true);
              }}
            >
              {/* {selectedTransactions.length > 0 &&
                "Selected Transactions " + selectedTransactions.length} */}
                {(selectAll
                  ? (searchResults.length > 0 && totalFoundTransactions && 
                      `Selected Transactions ${totalFoundTransactions}`)
                  : (selectedTransactions.length > 0 && 
                      `Selected Transactions ${selectedTransactions.length}`))}
            </div>
            <div>
                {searchResults.length > 0 &&
                  totalFoundTransactions &&
                  "Total Transactions " + totalFoundTransactions}
              </div>
              </div>
              {!searchResults ? (
                <Spin />
              ) : !selectAll ? (
                <div
                  className="searchResults"
                  style={{ maxHeight: "10rem", overflowY: "auto" }}
                  id="transactions-search"
                  onScroll={handleScroll}
                >
                  {searchResults.length > 0 ? (
                    searchResults.map((transaction) => (
                      <div
                        key={transaction.id}
                        style={{
                          display: "flex",
                          alignItems: "center",
                          padding: "8px",
                          borderBottom: "1px solid #ddd",
                          cursor: "pointer",
                        }}
                        onClick={() => toggleTransactionSelection(transaction)}
                      >
                        <Checkbox
                          checked={selectedTransactions.some(
                            (t) => t.id === transaction.id
                          )}
                          onClick={(event) => event.stopPropagation()}
                          onChange={(event) => {
                            event.stopPropagation(); // Prevents the div's onClick from being triggered
                            toggleTransactionSelection(transaction);
                          }}
                          // onChange={() => toggleTransactionSelection(transaction)}
                        />
                        <span style={{ marginLeft: "1rem" }}>
                          {transaction.itemName}
                        </span>
                        <span style={{ marginLeft: "1rem" }}>
                          {transaction.date
                            ? moment(transaction.date).format("MM-DD-YYYY")
                            : "N/A"}
                        </span>
                        {transaction.amount &&
                       <span style={{ marginLeft: "1rem" }}>
                        {transaction.amount }
                        </span>
                        }
                      </div>
                    ))
                  ) : (
                    <p style={{ color: "#aaa", textAlign: "center" }}>
                     {newPattern.pattern ? "No transactions found" : null}
                    </p>
                  )}
                </div>
              ): null} 
            </React.Fragment>
          )}
          
          
        </div>
      </div>

      <div className="buttonsMain" style={{ justifyContent: "center" }}>
        <button className="cancelbutton" onClick={handleCancel}>
          Cancel
        </button>
      </div>
      <NewLoader isLoading={loading} />
    </Modal>
    <Modal
            visible={isModalOpen}
            footer={null}
            onOk={() => setIsModalOpen(false)}
            onCancel={() => setIsModalOpen(false)}
            closable={false}
            centered
          >
            <h3 className="modaltitle">Transaction Details</h3>
            <h3 className="modaltitle">
              {selectedTransactions.length} Transactions
            </h3>
    
            <div>
              <div
                className=""
                style={{ height: "18rem", maxHeight: "18rem", overflow: "auto" }}
                id="transactions-main"
              >
                {selectedTransactions && selectedTransactions.length > 0 ? (
                  <table id="clients">
                    <thead>
                      <tr>
                        <th
                          style={{
                            cursor: "pointer",
                            display: "flex",
                            alignItems: "center",
                            gap: "8px",
                          }}
                        >
                          Date
                        </th>
                        <th>Name</th>
                        <th>Category</th>
                      </tr>
                    </thead>
                    <tbody style={{}}>
                      {selectedTransactions &&
                        selectedTransactions.map((data, index) => (
                          <tr key={index}>
                            <td>
                              {data && data.date
                                ? moment(data.date).format("MM-DD-YYYY")
                                : "N/A"}
                            </td>
                            <td>{data && data.itemName ? data.itemName : "N/A"}</td>
                            <td>
                              {data &&
                              data.transactionCategory &&
                              data.transactionCategory.categoryName
                                ? data.transactionCategory.categoryName
                                : "N/A"}
                            </td>
                          </tr>
                        ))}
                    </tbody>
                  </table>
                ) : (
                  <h3 className="inputTitle">No Transaction to Show</h3>
                )}
              </div>
            </div>
    
            <div className="buttonsMain" style={{ justifyContent: "center" }}>
              <button
                className="savebutton"
                onClick={() => {
                  setIsModalOpen(false);
                }}
              >
                Close
              </button>
            </div>
          </Modal>
    </div>
  );
};
